export const PROFESSOR_TUTORIAL_RESTART_EVENT = "livingsoils:professor-tutorial-restart";
export const PROFESSOR_TUTORIAL_OPEN_CREATE_EVENT = "livingsoils:professor-tutorial-open-create";
export const PROFESSOR_TUTORIAL_OPEN_IMPORT_EVENT = "livingsoils:professor-tutorial-open-import";
export const PROFESSOR_TUTORIAL_REFRESH_EVENT = "livingsoils:professor-tutorial-refresh";
export const PROFESSOR_TUTORIAL_SESSION_KEY = "livingsoils.professorTutorial.active";

export function dispatchProfessorTutorialRestart() {
  if (typeof window === "undefined") return;
  window.dispatchEvent(new CustomEvent(PROFESSOR_TUTORIAL_RESTART_EVENT));
}

export function dispatchProfessorTutorialOpenCreate() {
  if (typeof window === "undefined") return;
  window.dispatchEvent(new CustomEvent(PROFESSOR_TUTORIAL_OPEN_CREATE_EVENT));
}

export function dispatchProfessorTutorialOpenImport() {
  if (typeof window === "undefined") return;
  window.dispatchEvent(new CustomEvent(PROFESSOR_TUTORIAL_OPEN_IMPORT_EVENT));
}

export function dispatchProfessorTutorialRefresh(detail = {}) {
  if (typeof window === "undefined") return;
  window.dispatchEvent(new CustomEvent(PROFESSOR_TUTORIAL_REFRESH_EVENT, { detail }));
}
